export default function initializeSingleProduct() {
    initializeReviewsForm();
}

function initializeReviewsForm() {
    let commentsForm = document.querySelectorAll('#commentform');

    if (!commentsForm) {
        return;
    }

    commentsForm.forEach(function (form) {
        let formButton = form.querySelector('#submit');
        let formComment = form.querySelector('#comment');

        if (formButton && formComment) {
            formButton.addEventListener('click', function (e) {
                if (formComment.value.length < 5) {
                    alert('Treść komentarza jest zbyt krótka');
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        }
    });
}